module.exports = {
      id: "follow-facebook-usage",
      viewBox: "0 0 29 28",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#follow-facebook",
      toString: function () {
        return this.url;
      }
    }